import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useBangTongHopHoaDonBanHangHoaDichVuExport = (
  rows: BanHangRecord[] = [],
  queryParams?: BanHangSearchParams
) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug && rows.length === 0) {
      toast({
        description: 'Không tìm thấy dữ liệu để xuất.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportBangTongHopHoaDonBanHangExcel, exportBangTongHopHoaDonBanHangFromApi } =
        await import('../utils/excel-export');
      if (entity?.slug) {
        await exportBangTongHopHoaDonBanHangFromApi({
          entitySlug: entity.slug,
          queryParams,
          excelOptions: {}
        });
      } else {
        await exportBangTongHopHoaDonBanHangExcel(rows);
      }
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug) || rows.length > 0,
    isExporting
  };
};
